//import FocusTileWidgetComponent from "./FocusTileWidgetComponent";
{/*<FocusTileWidgetComponent layout={layout} />*/ }
const FocusTileWidget = ({ layout }) => (
  
   <div>FokusTile</div>
);

export default FocusTileWidget;